import { useEffect } from "react";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  if (!href) return;
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Lightweight per-page SEO: title, description, canonical, and Open Graph tags.
export function useSeo({ title, description, canonical, image } = {}) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;
    if (description) setMeta("name", "description", description);
    if (title) setMeta("property", "og:title", title);
    if (description) setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    if (canonical) { setMeta("property", "og:url", canonical); setCanonical(canonical); }
    if (image) setMeta("property", "og:image", image);
    return () => { document.title = prevTitle; };
  }, [title, description, canonical, image]);
}
